"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortTimezoneAbbreviation = void 0;
const utils_1 = require("./utils");
// this plugin needs advancedFormat to function properly
const shortTimezoneAbbreviation = (_, c) => {
    const proto = c.prototype;
    const oldFormat = proto.format;
    proto.format = function (formatStr) {
        if (!this.isValid()) {
            return oldFormat.bind(this)(formatStr);
        }
        const str = formatStr || 'YYYY-MM-DDTHH:mm:ssZ';
        // this regular expression matches formats that use the single `z` token
        // because this is not handled correctly by the original dayjs implementation (locale issue)
        const regexp = /^[^z]*z[^z]*$/u;
        // if the format string contains the `z` token, we replace it with `zzz`
        // which is going to give us the long timezone abbreviation (e.g. `Central European Standard Time` instead of `CET`)
        // because, weirdly, the long abbreviation is correctly handled by the library
        const hasShortAbbreviationFormat = str.match(regexp);
        // if no need of the short abbreviation, we call the original implementation
        if (!hasShortAbbreviationFormat) {
            return oldFormat.bind(this)(str);
        }
        // if yes, we replace it by the long abbreviation for now
        const finalStr = str.replace('z', 'zzz');
        // we call the previous implementation of the format method
        // so we can get long abbreviation for the timezone
        const formattedDate = oldFormat.bind(this)(finalStr);
        // then, we replace the long abbreviation by the short one
        return (0, utils_1.longToShortAbbreviation)(formattedDate);
    };
};
exports.shortTimezoneAbbreviation = shortTimezoneAbbreviation;
//# sourceMappingURL=index.js.map